/**
 * PageContacts JS controller.
 */

import Common from './common';

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class PageContacts
 */
export default class PageContacts {

    /**
     * Cache dom elements for use in the class's methods.
     *
     * @return {void}
     */
    cache() {

        // Region select.
        this.regionSelect = document.getElementById( 'js-region-select' );

        // Contacts wrapper.
        this.contactsWrapper = $( '#js-contacts-wrapper' );

        // Offices select.
        this.officesSelect = document.getElementById( 'js-offices-select' );

        // gmaps container.
        this.gmapsContainer = document.getElementById( 'js-gmaps-container' );

        // Spinner.
        this.spinner = $( '#js-spinner' );

        // Contacts count.
        this.contactsPostCount = $( '#js-contacts-post-count' );

        // Initial contacts list HTML.
        this.initialData = this.contactsWrapper.html();

        // Offices for map.
        this.offices = $( '.js-office' );

    }

    /**
     * All common events.
     *
     * @return {void}
     */
    events() {

        window.createMap = () => this.createMap();

        window.addEventListener('CookiebotOnConsentReady', () => {
            // If statistics cookies are accepted
            if (Cookiebot.consent.statistics) {
                this.createMap();
            }
        }, false);
    }

    /**
     * Init Google Maps.
     *
     * @return {void|object}
     */
    initMap() {

        const map = new google.maps.Map( this.gmapsContainer, {
            center: { lat: 63.0692149, lng: 21.3552433 },
            zoom: 5,
            mapTypeControl: false,
            streetViewControl: false,
            mapId: "CONTACTS",
        } );

        const officeCoordinates = [];
        const markers = [];
        const titles = [];
        const contents = [];

        this.offices.each( function ( index ) {

            // Get coordinates.
            const latitude = this.getAttribute( 'data-latitude' );
            const longitude = this.getAttribute( 'data-longitude' );

            // Get title & content.
            const title = this.getAttribute( 'data-title' );
            const content = this.querySelector( '.js-office-map-content' ).innerText;

            // If there's coordinates, put them inside officeCoordinates array.
            if ( latitude !== '' && longitude !== '' ) {

                const coordinates = new google.maps.LatLng( latitude, longitude );
                officeCoordinates.push( coordinates );

                // Put title & content inside arrays.
                titles.push( title );
                contents.push( content );
            }
        } );

        //  Create a new viewpoint bound
        const bounds = new google.maps.LatLngBounds();

        // Create markers.
        for ( let i = 0; i < officeCoordinates.length; i++ ) {

            const kuusamoIcon = document.createElement("img");
            kuusamoIcon.src = themeData.templateUrl + '/assets/images/map-mark.svg';

            //  And increase the bounds to take this point.
            bounds.extend( officeCoordinates[ i ] );

            markers[ i ] = new google.maps.marker.AdvancedMarkerElement( {
                position: officeCoordinates[ i ],
                content: kuusamoIcon,
                map: map,
            } );

            // Add click event listerner to markers.
            google.maps.event.addListener( markers[ i ], 'click', function () {

                const title = titles[ i ];
                const content = contents[ i ];

                const contentString = '<div class="map-content-container"><h4 class="map-heading">' + title + '</h4><div class="map-content"><p>' + content + '</p></div></div>';

                const infowindow = new google.maps.InfoWindow( {
                    content: contentString
                } );

                infowindow.open( map, markers[ i ] );
            } );
        };

        // Bounds to the map.
        map.setCenter( bounds.getCenter() );
        map.setZoom( 4.5 );

        return map;
    }

    /**
     * Show Google Maps inside gmaps container.
     *
     * @return {void|object}
     */
    createMap() {

        // Return early if there's no map container or google.maps is not working for some reason.
        if ( ! this.gmapsContainer || typeof google !== 'object' || typeof Cookiebot !== 'object' ) {
            return;
        }

        // Only initialise map if statistics cookies are accepted
        if (Cookiebot.consent.statistics) {
            this.initMap();   
        }
    }

    /**
     * Go to office's URL if select field's option is clicked.
     *
     * @return {void}
     */
    selectOffice() {

        // Return early if there's no offices select field.
        if ( ! this.officesSelect ) {
            return;
        }

        this.officesSelect.onchange = function () {
            window.location.replace( this.options[ this.selectedIndex ].value );
        };
    }

    /**
     * Show contacts by region.
     *
     * @return {void}
     */
    selectRegion() {

        // Assign this to thisClass to pass inside success.
        const thisClass = this;

        if ( ! Common.empty( this.regionSelect ) ) {

            this.regionSelect.onchange = function () {

                const selectValue = this.options[ this.selectedIndex ].value;
                let modelMethod = 'PageContacts/ContactsByRegion';

                if ( selectValue === '' ) {
                    modelMethod = 'PageContacts/Contacts';
                }

                // Show spinner & hide wrapper.
                thisClass.spinner.removeClass( 'hidden' );
                thisClass.contactsWrapper.addClass( 'loading' );

                // Query AJAX request.
                dp( modelMethod, {
                    tidy: true,
                    data: true,
                    partial: 'load-contacts',
                    args: {
                        /*eslint-disable */
                        ajax_params: {
                            value: selectValue,
                        }
                        /*eslint-enable */
                    }
                } ).then( ( response ) => {
                    let postCount = response.post_count;

                    if ( modelMethod === 'PageContacts/Contacts' ) {
                        postCount = response.data.post_count;
                    }

                    // Hide spinner & show wrapper.
                    thisClass.spinner.addClass( 'hidden' );
                    thisClass.contactsWrapper.removeClass( 'loading' );

                    // Update contacts list.
                    if ( modelMethod === 'PageContacts/Contacts' ) {
                        thisClass.contactsWrapper.html( thisClass.initialData );
                    } else {
                        thisClass.contactsWrapper.html( '<div class="contacts-group">' + response.success + '</div>' );
                    }

                    // Update contacts number on tabs.
                    thisClass.contactsPostCount.html( postCount );
                } ).catch( ( error ) => {
                    console.log( error );
                } );
            };
        }
    }

    /**
     * Run when the document is ready.
     *
     * @return {void}
     */
    docReady() {
        this.cache();
        this.events();
        this.selectOffice();
        this.selectRegion();
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/page-contacts.js